export default __webpack_public_path__ + "668160748423d884d68f0fbab3a4dfa3.ttf";